import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { CallResponse } from '../models/call.model';
import {
  CallAssignmentRequest,
  CallAssignmentResponse,
  CallTransferRequest
} from '../models/call-routing.model';

@Injectable({ providedIn: 'root' })
export class CallRoutingApiService {
  private readonly http = inject(HttpClient);
  private readonly base = `${environment.apiUrl}api/calls/routing`;

  getStatus(callId: number): Observable<CallResponse> {
    return this.http.get<CallResponse>(`${this.base}/${callId}`);
  }

  hold(callId: number): Observable<CallResponse> {
    return this.http.post<CallResponse>(`${this.base}/${callId}/hold`, {});
  }

  resume(callId: number): Observable<CallResponse> {
    return this.http.post<CallResponse>(`${this.base}/${callId}/resume`, {});
  }

  transfer(callId: number, req: CallTransferRequest): Observable<CallResponse> {
    return this.http.post<CallResponse>(`${this.base}/${callId}/transfer`, req);
  }

  assign(callId: number, req: CallAssignmentRequest): Observable<CallAssignmentResponse> {
    return this.http.post<CallAssignmentResponse>(`${this.base}/${callId}/assign`, req);
  }

  close(callId: number): Observable<CallResponse> {
    return this.http.post<CallResponse>(`${this.base}/${callId}/close`, {});
  }
}
